import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/benefits-calculator/BenefitsCalculatorClient.tsx");
